"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarSettingsModal = void 0;
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const calendar_settings_context_1 = require("./calendar-settings-context");
const cs_body_1 = require("./components/cs-body");
const cs_footer_1 = require("./components/cs-footer");
const cs_sidebar_1 = require("./components/cs-sidebar");
const CalendarSettingsModal = () => {
    return (react_1.default.createElement(calendar_settings_context_1.CalendarSettingsProvider, null, ({ loading }) => (react_1.default.createElement(ui_1.Modal, { size: 'size-l', sidebarContent: loading ? null : react_1.default.createElement(cs_sidebar_1.CSSidebar, null), headerContent: react_1.default.createElement(ui_1.Text, { weight: 'bold' }, (0, util_1.t)('CALENDAR_SETTINGS')), footerContent: react_1.default.createElement(cs_footer_1.CSFooter, null) }, loading ? react_1.default.createElement(ui_1.Loader, null) : react_1.default.createElement(cs_body_1.CSBody, null)))));
};
exports.CalendarSettingsModal = CalendarSettingsModal;
